/**
 * Relevé's own public identity values, used wherever the app names them —
 * one home so a change lands everywhere at once.
 */

/** Relevé's public contact address (the app footer, the Subscription page's Enterprise card). */
export const RELEVE_CONTACT_EMAIL = 'hello@releve.life';
